import { render, staticRenderFns } from "./CmsLayout.vue?vue&type=template&id=2b8a7c5e&scoped=true"
import script from "./CmsLayout.vue?vue&type=script&lang=js"
export * from "./CmsLayout.vue?vue&type=script&lang=js"
import style0 from "./CmsLayout.vue?vue&type=style&index=0&id=2b8a7c5e&prod&lang=css"
import style1 from "./CmsLayout.vue?vue&type=style&index=1&id=2b8a7c5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8a7c5e",
  null
  
)

export default component.exports